import { render, staticRenderFns } from "./QuickChatNotification.vue?vue&type=template&id=700968c9&scoped=true&"
import script from "./QuickChatNotification.vue?vue&type=script&lang=ts&"
export * from "./QuickChatNotification.vue?vue&type=script&lang=ts&"
import style0 from "./QuickChatNotification.vue?vue&type=style&index=0&id=700968c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700968c9",
  null
  
)

export default component.exports